import Vue from "vue";
import utils from "../utils/mutationHelpers";

export default {
  setInitialData(state, data) {
    Vue.set(state.initialData, `basepath`, data.basepath);
    Vue.set(state.initialData, `currents`, data.currents);
    Vue.set(state.initialData, `currentsResources`, data.currentsResources);
    Vue.set(state.initialData, `durations`, data.durations);
    Vue.set(state.initialData, `equipment`, data.equipment);
    Vue.set(state.initialData, `focus`, data.focus);
    Vue.set(state.initialData, `focusList`, data.focusList);
    Vue.set(state.initialData, `bodyPart`, data.bodyPart);
    Vue.set(state.initialData, `levels`, data.levels);
    Vue.set(state.initialData, `teachers`, data.teachers);
    Vue.set(state.initialData, `styles`, data.yogaStyles);
    Vue.set(state.initialData, `tempo`, data.tempo);
    Vue.set(state.initialData, `seriesContent`, data.seriesContent);
    Vue.set(state.initialData, `collectionsContent`, data.collectionsContent);
    Vue.set(state.initialData, `seriesCategories`, data.seriesCategories);
    Vue.set(state.initialData, `popular`, data.popular.map(item => `${item.id}`));
  },

  setUserData(state, data) {
    Vue.set(state.user, `isLoggedIn`, data.isLoggedIn);
    Vue.set(state.user, `level`, data.level);
    Vue.set(state.user, `nextPayment`, data.nextPayment);
    Vue.set(state.user, `name`, data.name);
    Vue.set(state.user, `subType`, data.subType);
    Vue.set(state.user, `hasToken`, data.hasToken);
    Vue.set(state.user, `email`, data.email);
    Vue.set(state.user, `myVideos`, data.myVideos);
    Vue.set(state.user, `mySeries`, data.mySeries);
    Vue.set(state.user, `history`, data.history);
    Vue.set(state.user, `seriesHistory`, data.seriesHistory);
    Vue.set(state.user, `myTeachers`, data.myTeachers);
    Vue.set(state.user, `accountStatus`, data.accountStatus);

    utils.setConfig(Vue, state.user.emailConfig, data.emailConfig);
    utils.setConfig(Vue, state.user.remindersConfig, data.remindersConfig);
    utils.setConfig(Vue, state.user.xpConfig, data.xpConfig);
    utils.setConfig(Vue, state.user.interestConfig, data.interestConfig);
    utils.setConfig(Vue, state.user.currentConfig, data.currentConfig);
    utils.setConfig(Vue, state.user.durationConfig, data.durationConfig);
    utils.setConfig(Vue, state.user.tempoConfig, data.tempoConfig);

    Vue.set(state.user, `playlists`, data.playlists);
    Vue.set(state.user, `myViews`, data.myViews);
    Vue.set(state.user, `totalViews`, data.totalViews);
  },

  isNotLoggedIn(state) {
    Vue.set(state.user, `isLoggedIn`, 0);
  },

  mergeCr(state, list) {
    Vue.set(state, `currents`, list);
  },

  setVideoList(state, list) {
    Vue.set(state, `videos`, list);
  },

  setSortBy(state, option) {
    Vue.set(state.sort, "sortby", option);
  },

  setGvList(state, list) {
    Vue.set(state, `series`, list);
  },

  setSeriesVideoList(state) {
    state.series.forEach(s => {
      const idList = s.videoItems.split(`||`);
      const videoList = state.videos.filter(v => {
        if (idList.includes(`${v.id}`)) {
          return true;
        }
        return false;
      });
      Vue.set(s, `videoList`, videoList);
    });
  },

  setOption(state, option) {
    // const conf = state.user[option.config];
    if (option.selected === false) {
      Vue.set(state.user, option.selected, true);
    }
    Vue.set(state.user, option.selected, false);
  },
  setSingleOption(state, option) {
    const conf = state.user[option.config];

    if (option.selected === true) {
      conf.forEach(item => {
        if (item.id !== option.id) {
          Vue.set(item, `selected`, false);
        }
      });

      Vue.set(state.user, option.selected, true);
    }
    Vue.set(state.user, option.selected, false);
  },

  // createCurrentConfig(state, list) {
  //   const parsed = [];
  //   list.forEach(item => {
  //     const obj = {
  //       id: item.id,
  //       label: item.label,
  //       selected: false
  //     };
  //     parsed.push(obj);
  //   });
  //   Vue.set(state.user, `currentConfig`, parsed);
  // },

  // createStyleConfig(state, list) {
  //   const parsed = [];
  //   list.forEach(item => {
  //     const obj = {
  //       id: item.id,
  //       label: item.label,
  //       includes: item.includes,
  //       selected: false
  //     };
  //     parsed.push(obj);
  //   });
  //   Vue.set(state.user, `styleConfig`, parsed);
  // },

  addToLikes(state, item) {
    const video = state.videos.filter(obj => {
      if (`${obj.id}` === `${item.id}`) {
        return true;
      }
      return false;
    });
    state.user.myVideos.push(`${video[0].id}`);
  },

  removeFromLikes(state, item) {
    let target;

    state.user.myVideos.forEach((video, index) => {
      if (`${item.id}` === video) {
        target = index;
      }
    });

    state.user.myVideos.splice(target, 1);
  },

  addSeries(state, item) {
    state.user.mySeries.push(item.id);
  },

  removeSeries(state, item) {
    let target;

    state.user.mySeries.forEach((series, index) => {
      if (item.id === series) {
        target = index;
      }
    });

    state.user.mySeries.splice(target, 1);
  },

  addTeacher(state, item) {
    const teacher = state.initialData.teachers.filter(obj => {
      if (obj.id === item.id) {
        return true;
      }
      return false;
    });

    if (state.user.myTeachers.length > 0) {
      Vue.set(
        state.user,
        `myTeachers`,
        `${state.user.myTeachers},${teacher[0].id}`
      );
    } else {
      Vue.set(state.user, `myTeachers`, `${teacher[0].id}`);
    }
  },

  removeTeacher(state, item) {
    let target;

    const arr = state.user.myTeachers.split(`,`);

    arr.forEach((t, index) => {
      if (item.id === t) {
        target = index;
      }
    });

    arr.splice(target, 1);

    Vue.set(state.user, `myTeachers`, arr.join(`,`));
  },

  sortSelectOption(state, option) {
    const arr = Object.values(state.sort.selected);
    arr.forEach(opt => {
      if (opt.category === option.category) {
        Vue.set(opt, `value`, option.id);
        if (opt.category === `cr`) {
          Vue.set(opt, `tag`, option.resource.id);
        }
      }
    });
  },

  toggleSelection(state, category) {
    const arr = Object.values(state.sort.selected);
    arr.forEach(opt => {
      if (opt.category === category) {
        Vue.set(opt, `open`, !opt.open);
      } else {
        Vue.set(opt, `open`, false);
      }
    });
  },
  resetSelection(state, category) {
    const arr = Object.values(state.sort.selected);
    arr.forEach(opt => {
      if (opt.category === category) {
        Vue.set(opt, `value`, `all`);
      }
    });
  },
  setSearchTerm(state, term) {
    Vue.set(state.sort, `term`, term);
  },

  setSearchParams(state, payload) {
    Vue.set(state.sort, `selected`, payload);
  },

  removeSearchParam(state, payload) {
    let temp = state.sort.selected;
    let remove = -1;
    if (temp[payload.type]) {
      temp[payload.type].forEach((item, index) => {
        if (item.id === payload.option.id) {
          remove = index;

          state.sort.selected[payload.type].splice(remove, 1);
        }
      });
    }
  },

  sortSetResults(state, results) {
    if (state.sort.sortby === 1) {
      results.sort(
        (a, b) => parseInt(b.videoRating, 10) - parseInt(a.videoRating, 10)
      );
    }

    if (state.sort.sortby === 2) {
      results.sort(
        (a, b) => Date.parse(b.publishedon) - Date.parse(a.publishedon)
      );
    }

    if (state.sort.sortby === 3) {
      results.sort((a, b) => a.pagetitle.localeCompare(b.pagetitle));
    }

    Vue.set(state.sort, `results`, results);
  },
  showHideSpinner(state, bool) {
    Vue.set(state.sort, `showSpinner`, bool);
  },
  cleanResults(state) {
    Vue.set(state.sort, `results`, []);
    Vue.set(state.sort, `showNoResults`, false);
    Vue.set(state.sort, "page", 1);
  },
  showNoResults(state, bool) {
    Vue.set(state.sort, `showNoResults`, bool);
  },
  addPage(state) {
    Vue.set(state.sort, "page", state.sort.page + 1);
  },

  addToSeriesHistory(state, payload) {
    let index = ``;
    let arr = [];

    if (Array.isArray(state.user.seriesHistory)) {
      arr = state.user.seriesHistory.filter((item, i) => {
        if (`${item.id}` === `${payload.sid}`) {
          index = i;
          return true;
        }
        return false;
      });
    }

    if (arr.length > 0) {
      const watched = arr[0].watched.split(`,`);
      watched.push(payload.done);

      Vue.set(state.user.seriesHistory[index], `watched`, watched.join(`,`));
    } else {
      state.user.seriesHistory.push({
        id: payload.sid,
        watched: `${payload.done}`
      });
    }
  },

  flashMessage(state, message) {
    Vue.set(state.flashMessage, `message`, message);
    Vue.set(state.flashMessage, `visible`, true);
    window.setTimeout(() => {
      Vue.set(state.flashMessage, `visible`, false);
      Vue.set(state.flashMessage, `message`, ``);
    }, 3000);
  },

  changeName(state, name) {
    Vue.set(state.user, `name`, name);
  },

  histBringToFront(state, vid) {
    const index = state.user.history.indexOf(vid);
    state.user.history.splice(index, 1);
    state.user.history.unshift(vid);
  },
  addToHistory(state, vid) {
    state.user.history.unshift(vid);
  },

  addError(state, error) {
    state.errors.push(error);
  },
  getYogaStyles(state, getters) {
    const styles = state.initialData.styles;
    const notYoga = [
      ...styles[1].includes,
      ...styles[2].includes,
      ...styles[3].includes
    ];
    const filtered = getters.currentIds.filter(
      i => notYoga.indexOf(parseInt(i, 10)) === -1
    );

    Vue.set(styles[0], `includes`, filtered);
  },

  setAccountType(state, type) {
    let t;
    if (type === 1) {
      t = `2`;
    } else {
      t = `1`;
    }
    Vue.set(state.user, `subType`, t);
  },

  setFeedbackSent(state) {
    Vue.set(state.teacherFeedback, `showSpinner`, false);
  },

  setFeedbackSending(state) {
    Vue.set(state.teacherFeedback, `showSpinner`, true);
    Vue.set(state.teacherFeedback, `sending`, true);
  },

  setFeedbackError(state) {
    Vue.set(state.teacherFeedback, `error`, true);
    Vue.set(state.teacherFeedback, `showSpinner`, false);
  },

  setFeedbackReset(state) {
    Vue.set(state.teacherFeedback, `showSpinner`, false);
    Vue.set(state.teacherFeedback, `sending`, false);
    Vue.set(state.teacherFeedback, `error`, false);
  },
  setPlaylistSelected(state, playlistId){
    Vue.set(state.user, 'playlistSelected', playlistId);
  },
  addToPlaylist(state, payload){
    state.user.currentPlaylist[payload.category].push(payload.toAdd);
  },
  removeFromPlaylist(state, payload){
    let list = state.user.currentPlaylist[payload.category];
    const idx = list.indexOf(payload.toRemove);
    if(idx > -1){
      list.splice(idx, 1);
    }
  },
  updatePlaylist(state, playlist){
    Vue.set(state.user, 'currentPlaylist', playlist);
  }
};
